import { render, staticRenderFns } from "./ModalFiltrarUnimeds.vue?vue&type=template&id=c2cd7f6e&scoped=true"
import script from "./ModalFiltrarUnimeds.vue?vue&type=script&lang=js"
export * from "./ModalFiltrarUnimeds.vue?vue&type=script&lang=js"
import style0 from "./ModalFiltrarUnimeds.vue?vue&type=style&index=0&id=c2cd7f6e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cd7f6e",
  null
  
)

export default component.exports